// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: Arial, sans-serif;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.register-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}

.register-container h1 {
    color: #333;
    margin-bottom: 20px;
}

.register-container form {
    display: flex;
    flex-direction: column;
}

.register-container input[type="email"], input[type="password"], input[type="text"], input[type="pin"] {
    width: 100%;
    padding: 10px;
    border: 2px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
}

.register-container button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    display: block;
    width: 100%;
    margin-top: 10px;
}

.register-container button:hover {
    background-color: #0056b3;
}

.register-container .error {
    color: #ff0000;
    background-color: #ffe6e6;
    padding: 10px;
    border: 1px solid #ff0000;
    border-radius: 4px;
    margin-top: 10px;
    text-align: center;
    width: 100%;
}

.register-container .success {
    color: #008000;
    background-color: #e6ffe6;
    padding: 10px;
    border: 1px solid #008000;
    border-radius: 4px;
    margin-top: 10px;
    text-align: center;
    width: 100%;
}

.register-container .success a {
    color: #008000;
    font-weight: bold;
    text-decoration: none;
}

.register-container .success a:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Register.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    background-color: #f5f5f5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n}\n\n.register-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 400px;\n}\n\n.register-container h1 {\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.register-container form {\n    display: flex;\n    flex-direction: column;\n}\n\n.register-container input[type=\"email\"], input[type=\"password\"], input[type=\"text\"], input[type=\"pin\"] {\n    width: 100%;\n    padding: 10px;\n    border: 2px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 10px;\n}\n\n.register-container button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    display: block;\n    width: 100%;\n    margin-top: 10px;\n}\n\n.register-container button:hover {\n    background-color: #0056b3;\n}\n\n.register-container .error {\n    color: #ff0000;\n    background-color: #ffe6e6;\n    padding: 10px;\n    border: 1px solid #ff0000;\n    border-radius: 4px;\n    margin-top: 10px;\n    text-align: center;\n    width: 100%;\n}\n\n.register-container .success {\n    color: #008000;\n    background-color: #e6ffe6;\n    padding: 10px;\n    border: 1px solid #008000;\n    border-radius: 4px;\n    margin-top: 10px;\n    text-align: center;\n    width: 100%;\n}\n\n.register-container .success a {\n    color: #008000;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.register-container .success a:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
